// Asal: Abholtermin im Warenkorb (Drawer und Warenkorbseite). Daten aus dem Orangen Hub, ohne Bibliotheken.
(() => {
  const roots = () => [...document.querySelectorAll('[data-asal-pickup]')];
  if (!roots().length) return;

  const first = roots()[0];
  const state = {
    days: null,
    date: first.querySelector('[data-attr="date"]').value,
    time: first.querySelector('[data-attr="time"]').value,
    error: false,
  };

  const weekday = d => new Date(d + 'T12:00:00').toLocaleDateString('de-DE', { weekday: 'short' });
  const dayMonth = d => new Date(d + 'T12:00:00').toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit' });
  const longDate = (d => new Date(d + 'T12:00:00').toLocaleDateString('de-DE', { weekday: 'long' }) + ', ' + new Date(d + 'T12:00:00').toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }));
  const deadlineText = dl => {
    if (!dl) return '';
    const [d, t] = dl.split('T');
    return `Bestellschluss ${longDate(d)}, ${t} Uhr`;
  };
  const selectedDay = () => (state.days || []).find(d => d.date === state.date);
  const blocked = () => (window.AsalStock ? window.AsalStock.blocked : []);
  const valid = () => {
    if (blocked().length) return false;
    // Ist der Hub nicht erreichbar, nicht den Kauf blockieren – der Termin wird dann nachträglich abgestimmt.
    if (state.error) return true;
    const day = selectedDay();
    return !!day && day.bookable && day.slots.some(s => s.time === state.time && s.available);
  };

  const option = ({ label, sub, checked, disabled, few, onPick }) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'asal-pickup__option';
    b.setAttribute('role', 'radio');
    b.setAttribute('aria-checked', String(checked));
    b.disabled = disabled;
    const l = document.createElement('span');
    l.className = 'asal-pickup__label';
    l.textContent = label;
    const s = document.createElement('span');
    s.className = 'asal-pickup__sub' + (few ? ' is-few' : '');
    s.textContent = sub;
    b.append(l, s);
    b.addEventListener('click', onPick);
    return b;
  };

  const save = () => {
    const day = selectedDay();
    // _Abholort-ID (unsichtbar an der Kasse) ordnet die Bestellung im Hub eindeutig dem Standort zu.
    const attributes = { Abholdatum: state.date, Abholzeit: state.time, Abholort: day ? (day.place && day.place.name) || day.location || '' : '', '_Abholort-ID': day && day.place ? String(day.place.id) : '' };
    roots().forEach(root => {
      root.querySelector('[data-attr="date"]').value = attributes.Abholdatum;
      root.querySelector('[data-attr="time"]').value = attributes.Abholzeit;
      root.querySelector('[data-attr="location"]').value = attributes.Abholort;
      const pid = root.querySelector('[data-attr="place"]');
      if (pid) pid.value = attributes['_Abholort-ID'];
    });
    // Zur Kasse erst, wenn der Termin wirklich im Warenkorb gespeichert ist (langsame Verbindung, HTTP-Fehler).
    // Schreibvorgänge streng nacheinander (sonst kann eine ältere Anfrage nach einer neueren ankommen und z. B. 08:00 statt
    // 09:00 speichern). Die Kasse wartet, bis die Warteschlange leer ist; maßgeblich ist der zuletzt gewählte Stand.
    // Gemeinsame Warteschlange aus asal-place.js (auch der Ortswechsel schreibt dort hinein).
    state.saveError = false;
    const req = window.AsalCartAttrs.write(attributes)
      .then(ok => { if (pending === req) state.saveError = !ok; })
      .finally(() => { if (pending === req) pending = null; render(); });
    pending = req;
    return req;
  };
  let pending = null;
  // Läuft irgendein Schreibvorgang auf die Abhol-Attribute (eigener oder Ortswechsel)? Dann darauf warten.
  const busy = () => pending || (window.AsalCartAttrs && window.AsalCartAttrs.busy() ? window.AsalCartAttrs.idle() : null);

  const lockCheckout = locked => roots().forEach(root => {
    const form = root.closest('form');
    if (!form) return;
    // Nicht deaktivieren (sonst reagiert der Knopf gar nicht): Text ändern, Klick führt zur Terminwahl.
    form.querySelectorAll('[name="checkout"], .cart__checkout').forEach(b => {
      if (!b.dataset.asalLabel) b.dataset.asalLabel = b.textContent.trim();
      b.classList.toggle('is-locked', locked);
      b.setAttribute('aria-disabled', String(locked));
      b.textContent = locked ? (blocked().length ? 'Erst Artikel entfernen' : 'Erst Abholtermin wählen') : b.dataset.asalLabel;
    });
    form.querySelectorAll('.additional-checkout-buttons').forEach(el => { el.hidden = locked; });
  });

  const render = () => {
    const days = state.days || [];
    const day = selectedDay();
    roots().forEach(root => {
      const datesEl = root.querySelector('.asal-pickup__dates');
      const slotsEl = root.querySelector('.asal-pickup__slots');
      const statusEl = root.querySelector('.asal-pickup__status');
      datesEl.replaceChildren(...days.map(d => {
        const free = d.slots.reduce((n, s) => n + s.free, 0);
        return option({
          label: `${weekday(d.date)}, ${dayMonth(d.date)}`,
          sub: !d.bookable ? 'Buchung startet bald' : free === 0 ? 'ausgebucht' : free < 30 ? 'fast ausgebucht' : 'Plätze frei',
          checked: d.date === state.date, disabled: !d.bookable || free === 0, few: d.bookable && free > 0 && free < 30,
          onPick: () => { state.date = d.date; state.time = ''; render(); save(); },
        });
      }));
      slotsEl.replaceChildren(...(day ? day.slots.map(s => option({
        label: s.time.replace(/\s*-\s*/, '–'),
        sub: !s.available ? 'voll' : s.free <= 5 ? `noch ${s.free} frei` : 'frei',
        checked: s.time === state.time, disabled: !s.available, few: s.available && s.free <= 5,
        onPick: () => { state.time = s.time; render(); save(); },
      })) : []));
      slotsEl.hidden = !day;
      let msg = '';
      if (blocked().length) msg = `Nicht mehr bestellbar: ${blocked().join(', ')}. Bitte aus dem Warenkorb entfernen.`;
      else if (state.days === null) msg = 'Termine werden geladen …';
      else if (state.error) msg = 'Die Abholtermine konnten gerade nicht geladen werden. Du kannst trotzdem bestellen, wir melden uns wegen des Termins.';
      else if (state.days && !days.some(d => d.bookable)) msg = days.length ? 'Die Termine sind angekündigt, die Buchung startet in Kürze.' : 'Zurzeit sind keine Abholtermine buchbar. Sobald die nächsten Termine freigeschaltet sind, kannst du hier bestellen.';
      else if (state.saveError) msg = 'Dein Abholtermin konnte nicht gespeichert werden. Bitte wähle ihn noch einmal.';
      else if (!day) msg = 'Bitte wähle deinen Abholtermin.';
      else if (!valid()) msg = 'Bitte wähle ein Zeitfenster.' + (day.deadline ? ` ${deadlineText(day.deadline)}.` : '');
      else msg = `✓ Abholung ${longDate(day.date)}, ${state.time.replace(/\s*-\s*/, '–')} Uhr`;
      statusEl.textContent = msg;
      statusEl.classList.toggle('is-ok', valid());
    });
    lockCheckout(!valid() || state.saveError);
  };

  const load = async () => {
    try {
      // Termine des gewählten Abholorts (bei mehreren Orten) aus dem gemeinsamen Hub-Abruf.
      if (!window.AsalPlace) throw new Error('AsalPlace fehlt');
      state.days = (await window.AsalPlace.load()).days || [];
      state.error = false;
    } catch (e) {
      state.error = true;
      state.days = state.days || [];
    }
    // Gewählter Termin nicht mehr buchbar (oder anderer Ort): auch im Warenkorb leeren, damit nichts Veraltetes zur Kasse geht.
    if (state.date && !state.error && !state.days.some(d => d.date === state.date && d.bookable)) { state.date = ''; state.time = ''; save(); }
    render();
  };

  // Ohne gültigen Termin nicht zur Kasse (greift vor Impulse' eigenem Absenden).
  document.addEventListener('submit', e => {
    const form = e.target;
    if (!form.querySelector || !form.querySelector('[data-asal-pickup]')) return;
    const submitter = e.submitter;
    if (submitter && submitter.name !== 'checkout') return;
    if (valid() && !busy() && !state.saveError) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    // Speichern läuft noch: abwarten und dann erneut absenden
    const wait = valid() && busy();
    if (wait) { wait.then(() => { if (!state.saveError && valid() && !busy()) form.requestSubmit(submitter || undefined); }); return; }
    render();
    form.querySelector('[data-asal-pickup]').scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);

  // Anderer Abholort gewählt: Termin zurücksetzen und Termine des neuen Orts zeigen.
  document.addEventListener('asal:place', () => { state.date = ''; state.time = ''; save(); load(); });

  // Freie Plätze aktuell halten, wenn jemand zurück in den Tab kommt.
  document.addEventListener('visibilitychange', () => { if (!document.hidden) load(); });

  // Für die Vorschau-Prüfung: Termine von außen setzen.
  window.AsalPickup = { setDays: days => { state.days = days; state.error = false; render(); }, reload: load, refresh: () => render() };

  render();
  load();
})();
